import React, { type FC, memo, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { UploadFileStatus } from "@dms/types";
import { Spinner } from "@heroui/react";
import { CircleCheck, CloudSlash } from "@gravity-ui/icons";

interface IProps {
    file: File;
    status: UploadFileStatus;
    error?: string | false;
}

const UploadFileItemImpl: FC<IProps> = ({ file, status, error }) => {
    const errorValues = useMemo(() => ({ error }), [error]);
    return (
        <div className="flex w-full items-center justify-between">
            <div className="flex gap-2 items-center">
                {status === UploadFileStatus.READY_FOR_UPLOAD && <Spinner size="sm" color="current" />}
                {status === UploadFileStatus.PROGRESS && <Spinner size="sm" color="accent" />}
                {status === UploadFileStatus.DONE && <CircleCheck className={`size-4 ${"text-green-500"}`} />}
                {status === UploadFileStatus.ERROR && <CloudSlash className={`size-4 ${"text-red-500"}`} />}
                <div>{file.name}</div>
            </div>
            {error && (
                <div className="text-red-500">
                    <FormattedMessage id="app.dms.upload.errorLabel" values={errorValues} />
                </div>
            )}
        </div>
    );
};

export const UploadFileItem = memo(UploadFileItemImpl);
